import { typographyStyles, constants } from "@newsela/angelou";
const { textS } = typographyStyles;
const { ui } = constants.colors;

export const optionalDisclaimerCss = [
  {
    span: {
      color: ui.neutral[400],
    },
  },
  textS,
];

export const checkboxCustomCss = {
  root: {
    marginTop: "5px",
    background: "#F8F8F8",
    borderRadius: "4px",
  },
  checkedBox: {
    paddingRight: "0",
  },
  emptyCheckbox: {
    paddingRight: "0",
  },
  labelText: {
    paddingLeft: "12px",
  },
};
